export interface IAppNames {
  lombok: string;
  qris: string;
  claimAdmin: string;
  pos: string;
  [key: string]: string;
}

export const APP_NAMES: IAppNames = {
  lombok: "lombok",
  qris: "qris",
  claimAdmin: "claim-admin",
  pos: "pos",
};
